<template>
  <!-- <div class="chart"></div> -->
  <div>
    <div id="chart_div" />
    <div id="filter_div" />
  </div>
</template>

<script>
import { init } from './util'
export default {
  name: 'Chart',
  props: ['data', 'options', 'type', 'filter'],
  mounted() {
    init(
      this.$el,
      this.data,
      this.options,
      this.type,
      this.filter,
      this.$i18n.locale
    )
  },
  watch: {
    data() {
      init(
        this.$el,
        this.data,
        this.options,
        this.type,
        this.filter,
        this.$i18n.locale
      )
    }
  }
}
</script>
